module.exports = __webpack_public_path__ + "img/stat4.82c79d0e.svg";